var _path, _path2, _ellipse, _rect, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeC(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 17,
    viewBox: "0 0 28 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 8.98597C22.8139 12.0146 19.6744 16.9562 13.6048 16.9562C9.09661 16.9562 9.62791 13.7066 9.62791 9.30477C9.62791 4.90295 9.11513 0.704927 13.6048 1.01577C20.5116 1.49395 23.6512 6.4355 27 8.98597Z",
    fill: "#36C8F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-4.95911e-05 8.98596C4.186 5.95731 7.32553 1.01576 13.3951 1.01576C17.9033 1.01576 17.372 4.26533 17.372 8.66715C17.372 13.069 17.8848 17.267 13.3951 16.9562C6.48832 16.478 3.34879 11.5364 -4.95911e-05 8.98596Z",
    fill: "#36C8F6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.3953,
    cy: 8.98598,
    rx: 5.02326,
    ry: 3.8257,
    fill: "#194FC6",
    fillOpacity: 0.56
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.84259,
    y: 6.93164,
    width: 4.31475,
    height: 13.0858,
    transform: "rotate(-61.6025 5.84259 6.93164)",
    fill: "#36C8F6"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.71115,
    y1: 1.67881,
    x2: 26.7111,
    y2: 15.6788,
    stroke: "#194FC6",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeC);
export default __webpack_public_path__ + "static/media/eyeC.e8ca2d56164564f15a9baa1bfe1ff476.svg";
export { ForwardRef as ReactComponent };